import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Support from '@/components/Support'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Index',
    component: Index,
    meta: { title: 'showworld.com' }
  }, {
    path: '/support',
    name: 'Support',
    component: Support,
    meta: { title: '看看拍什么' }
  }]
})


// WEBPACK FOOTER //
// ./src/router/index.js